import { render, staticRenderFns } from "./ReferralPhaseWithReasonLabel.vue?vue&type=template&id=bc007248&"
import script from "./ReferralPhaseWithReasonLabel.vue?vue&type=script&lang=ts&"
export * from "./ReferralPhaseWithReasonLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports